(function () {
  if (window.__rgDualLotteryBooted) return;
  window.__rgDualLotteryBooted = true;

  var SLOT_COUNT = 8;
  var CLOCKWISE = [0, 1, 2, 4, 7, 6, 5, 3];

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return '';
  }

  function getSite() {
    switch (window.location.hostname) {
      case 'uk.renogy.com':
        return { site: 'UK', apiUrl: 'https://shopify-api.renogy.com' };
      case 'www.renogy.com':
        return { site: 'US', apiUrl: 'https://shopify-api.renogy.com' };
      case 'ca.renogy.com':
        return { site: 'CA', apiUrl: 'https://shopify-api.renogy.com' };
      case 'au.renogy.com':
        return { site: 'AU', apiUrl: 'https://shopify-api.renogy.com' };
      case 'de.renogy.com':
        return { site: 'DE', apiUrl: 'https://shopify-api.renogy.com' };
      case 'jp.renogy.com':
        return { site: 'JP', apiUrl: 'https://shopify-api.renogy.com' };
      case 'fr.renogy.com':
        return { site: 'FR', apiUrl: 'https://shopify-api.renogy.com' };
      case 'nl.renogy.com':
        return { site: 'NL', apiUrl: 'https://shopify-api.renogy.com' };
      case 'it.renogy.com':
        return { site: 'IT', apiUrl: 'https://shopify-api.renogy.com' };
      case 'es.renogy.com':
        return { site: 'ES', apiUrl: 'https://shopify-api.renogy.com' };
      case 'eu.renogy.com':
        return { site: 'EU', apiUrl: 'https://shopify-api.renogy.com' };
      case 'pl.renogy.com':
        return { site: 'PL', apiUrl: 'https://shopify-api.renogy.com' };
      case 'be.renogy.com':
        return { site: 'BE', apiUrl: 'https://shopify-api.renogy.com' };
      case 'ie.renogy.com':
        return { site: 'IE', apiUrl: 'https://shopify-api.renogy.com' };
      case 'at.renogy.com':
        return { site: 'AT', apiUrl: 'https://shopify-api.renogy.com' };
      case 'pt.renogy.com':
        return { site: 'PT', apiUrl: 'https://shopify-api.renogy.com' };
      default:
        return { site: 'RenogyTest', apiUrl: 'https://d-shopify-api.renogy.cn' };
    }
  }

  function variantId(value) {
    if (!value) return '';
    var text = String(value);
    var parts = text.split('/');
    return parts[parts.length - 1];
  }

  function boot(root) {
    if (!root || root.getAttribute('data-rg-dual-lottery-ready') === '1') return;
    var configNode = root.querySelector('[data-rg-dual-lottery-config]');
    if (!configNode) return;
    var config;
    try {
      config = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      return;
    }

    root.setAttribute('data-rg-dual-lottery-ready', '1');

    var site = getSite();
    var env = (window.renogyConfig && window.renogyConfig.mode) || '';
    var accessToken = getCookie('renogy_account_access_token_key_' + env + '_1.0');
    var prizeCache = {};
    var mode = 'subscribe';
    var spinning = false;
    var animation = null;
    var requestSerial = 0;

    var skeleton = root.querySelector('[data-rg-dual-lottery-skeleton]');
    var body = root.querySelector('[data-rg-dual-lottery-body]');
    var tabs = root.querySelector('[data-rg-dual-lottery-tabs]');
    var titleNode = root.querySelector('[data-rg-dual-lottery-title]');
    var descNode = root.querySelector('[data-rg-dual-lottery-desc]');
    var subscribePanel = root.querySelector('[data-rg-dual-lottery-subscribe]');
    var raysPanel = root.querySelector('[data-rg-dual-lottery-rays]');
    var grid = root.querySelector('[data-rg-dual-lottery-grid]');
    var messageNode = root.querySelector('[data-rg-dual-lottery-message]');
    var resultNode = root.querySelector('[data-rg-dual-lottery-result]');
    var emailInput = root.querySelector('[data-rg-dual-lottery-email]');
    var termsInput = root.querySelector('[data-rg-dual-lottery-terms]');
    var balanceNode = root.querySelector('[data-rg-dual-lottery-rays-balance]');
    var customerPoints = null;
    var heroNode = root.querySelector('[data-rg-dual-lottery-hero]');
    var subtitleNode = root.querySelector('[data-rg-dual-lottery-subtitle]');
    var rulesNode = root.querySelector('[data-rg-dual-lottery-rules]');
    var rulesMoreNode = root.querySelector('[data-rg-dual-lottery-rules-more]');
    var rulesPanelNode = root.querySelector('[data-rg-dual-lottery-rules-panel]');
    var countdownNode = root.querySelector('[data-rg-dual-lottery-countdown]');
    var countdownLabelNode = root.querySelector('[data-rg-dual-lottery-countdown-label]');
    var countdownValueNode = root.querySelector('[data-rg-dual-lottery-countdown-value]');
    var loginNode = root.querySelector('[data-rg-dual-lottery-login]');

    function activityFor(nextMode) {
      return nextMode === 'rays' ? config.raysActivity : config.subscribeActivity;
    }

    function slotConfig(nextMode) {
      var slots = nextMode === 'rays' ? config.raysPrizes : config.subscribePrizes;
      return Array.isArray(slots) ? slots : [];
    }

    function configured(value) {
      if (value == null) return false;
      return String(value).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0;
    }

    function imageOverride(nextMode, prizeId) {
      var slots = slotConfig(nextMode);
      for (var i = 0; i < slots.length; i += 1) {
        if (slots[i] && slots[i].prizeId === prizeId && slots[i].image) return slots[i].image;
      }
      return '';
    }

    function applyImage(prize, nextMode) {
      if (!prize) return prize;
      var next = Object.assign({}, prize);
      var slots = slotConfig(nextMode);
      var slot = null;
      for (var i = 0; i < slots.length; i += 1) {
        if (slots[i] && slots[i].prizeId === prize.prizeId) {
          slot = slots[i];
          break;
        }
      }
      var image = (slot && slot.image) || imageOverride(nextMode, prize.prizeId);
      if (image) {
        var detail = Object.assign({}, prize.productDetail || prize.prizeProductDetail || {});
        detail.image = image;
        next.productDetail = detail;
      }
      if (slot) {
        if (configured(slot.prizeName)) next.title = slot.prizeName;
        if (configured(slot.prizeDescription)) next.useLimit = slot.prizeDescription;
        if (configured(slot.minPurchase)) next.minPurchase = slot.minPurchase;
        if (configured(slot.validDate)) next.validate = slot.validDate;
        if (configured(slot.rules)) next.rulesHtml = slot.rules;
        if (configured(slot.couponTypeName)) next.couponTypeName = slot.couponTypeName;
      }
      return next;
    }

    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function renderCountdown() {
      if (!countdownNode) return;
      var phase = activityPhase();
      var now = Date.now();
      var start = Date.parse(config.timeStart || '');
      var end = Date.parse(config.timeEnd || '');
      var target = 0;
      var label = '';
      var show = mode === 'rays' && config.showCountdown && phase !== 'ended';
      if (show && phase === 'soon' && config.showStartCountdown && !isNaN(start)) {
        target = start;
        label = config.startCountdownText || '';
      } else if (show && phase === 'open' && config.showEndCountdown && !isNaN(end) && now < end && (end - now) <= 3 * 24 * 60 * 60 * 1000) {
        target = end;
        label = config.endCountdownText || '';
      }
      if (!target) {
        countdownNode.hidden = true;
        return;
      }
      var remain = Math.max(0, target - now);
      var totalSeconds = Math.floor(remain / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      function box(value, unit) {
        var unitHtml = config.showTimeText && unit
          ? '<span class="rg-dual-lottery__countdown-unit">' + escapeHtml(unit) + '</span>'
          : '';
        return '<span class="rg-dual-lottery__countdown-box">' + pad(value) + '</span>' + unitHtml;
      }
      if (countdownLabelNode) countdownLabelNode.textContent = label;
      if (countdownValueNode) {
        countdownValueNode.innerHTML = [
          box(days, config.dayText),
          ':',
          box(hours, config.hourText),
          ':',
          box(minutes, config.minText),
          ':',
          box(seconds, config.secText)
        ].join('');
      }
      countdownNode.hidden = false;
    }

    function orderedPrizes(apiPrizes, nextMode) {
      var slots = slotConfig(nextMode);
      var list = Array.isArray(apiPrizes) ? apiPrizes : [];
      if (!slots.length) return list;
      var byId = {};
      list.forEach(function (prize) {
        if (prize && prize.prizeId) byId[prize.prizeId] = prize;
      });
      return slots.map(function (slot) {
        var id = (slot && slot.prizeId) || 'prize_none';
        if (!id || id === 'prize_none') return { prizeId: 'prize_none', image: (slot && slot.image) || '' };
        var prize = byId[id] ? Object.assign({}, byId[id]) : { prizeId: id, title: '', productDetail: {} };
        if (slot.image) {
          prize.productDetail = Object.assign({}, prize.productDetail || {}, { image: slot.image });
        }
        if (configured(slot.prizeName)) prize.title = slot.prizeName;
        if (configured(slot.prizeDescription)) prize.useLimit = slot.prizeDescription;
        if (configured(slot.minPurchase)) prize.minPurchase = slot.minPurchase;
        if (configured(slot.validDate)) prize.validate = slot.validDate;
        if (configured(slot.rules)) prize.rulesHtml = slot.rules;
        if (configured(slot.couponTypeName)) prize.couponTypeName = slot.couponTypeName;
        return prize;
      });
    }

    function showTabs() {
      if (!config.loggedIn) return true;
      return !config.subscribed;
    }

    function pickMode() {
      if (!config.loggedIn || config.subscribed) {
        return config.loggedIn && config.subscribed ? 'rays' : 'subscribe';
      }
      return mode === 'rays' ? 'rays' : 'subscribe';
    }

    function setMessage(text) {
      if (!messageNode) return;
      messageNode.textContent = text || '';
      messageNode.hidden = !text;
    }

    function activityPhase() {
      if (mode !== 'rays') return 'open';
      var now = Date.now();
      var start = Date.parse(config.timeStart || '');
      var end = Date.parse(config.timeEnd || '');
      if (!isNaN(start) && now < start) return 'soon';
      if (!isNaN(end) && now > end) return 'ended';
      return 'open';
    }

    function centerLabel() {
      var phase = activityPhase();
      if (mode === 'rays') {
        if (phase === 'soon') return config.playSoon || config.playText;
        if (phase === 'ended') return config.playEnded || config.playText;
        if (!config.loggedIn) return config.playLoggedOut || config.playText;
        return config.playText;
      }
      return config.subscribePlayText;
    }

    function fillRules(list, buttonText, panelHtml) {
      var items = (list || []).filter(function (item) { return item; });
      if (rulesNode) {
        rulesNode.innerHTML = items.map(function (item) {
          return '<li>' + escapeHtml(item) + '</li>';
        }).join('');
        rulesNode.hidden = !items.length;
      }
      if (rulesMoreNode) {
        rulesMoreNode.textContent = buttonText || '';
        rulesMoreNode.hidden = !buttonText;
      }
      if (rulesPanelNode) {
        rulesPanelNode.innerHTML = panelHtml || '';
        rulesPanelNode.hidden = true;
      }
    }

    function openRules() {
      var source = root.querySelector('[data-rg-dual-lottery-rules-source="' + mode + '"]');
      var html = source ? source.innerHTML : '';
      if (!String(html).trim() && rulesPanelNode) {
        html = '<div class="rg-component-dialog-text">' + rulesPanelNode.innerHTML + '</div>';
      }
      if (window.Swal && String(html).trim()) {
        window.Swal.fire({
          html: html,
          padding: '0',
          position: '',
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          closeButtonHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="1" y="1" width="24" height="24" rx="12" fill="white" fill-opacity="0.3"/><rect x="6.33295" y="18.4546" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-45 6.33295 18.4546)" fill="#1C1C1C"/><rect x="18.4548" y="19.667" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-135 18.4548 19.667)" fill="#1C1C1C"/></svg>',
          customClass: {
            container: 'pdp-learnMore-dialog-box',
            popup: 'pdp-learnMore-dialog-popup pdp-learnMore-dialog-popup-other'
          }
        });
      }
    }

    function paintTheme(isRays) {
      var theme = isRays
        ? {
          title: config.raysTitleColor,
          desc: config.raysDescriptionColor,
          accent: config.raysAccentColor,
          terms: config.raysTermsColor,
          termsLink: config.raysTermsLinkColor,
          btn: config.raysButtonColor,
          btnText: config.raysButtonTextColor,
          cell: config.raysCellColor,
          cellInner: config.raysCellInnerColor,
          active: config.raysActiveColor,
          star: config.raysStarImage,
          border: config.raysBorder,
          contentBg: config.raysContentBg
        }
        : {
          title: config.subscribeTitleColor,
          desc: config.subscribeDescriptionColor,
          accent: config.subscribeAccentColor,
          terms: config.subscribeTermsColor,
          termsLink: config.subscribeTermsLinkColor,
          btn: config.subscribeButtonColor,
          btnText: config.subscribeButtonTextColor,
          cell: config.subscribeCellColor,
          cellInner: config.subscribeCellInnerColor,
          active: config.subscribeActiveColor,
          star: config.subscribeStarImage,
          border: config.subscribeBorder,
          contentBg: config.subscribeContentBg
        };
      root.style.setProperty('--dual-title', theme.title || '');
      root.style.setProperty('--dual-desc', theme.desc || '');
      root.style.setProperty('--dual-accent', theme.accent || '');
      root.style.setProperty('--dual-terms', theme.terms || '');
      root.style.setProperty('--dual-terms-link', theme.termsLink || '');
      root.style.setProperty('--dual-btn', theme.btn || '');
      root.style.setProperty('--dual-btn-text', theme.btnText || '');
      root.style.setProperty('--dual-cell', theme.cell || '');
      root.style.setProperty('--dual-cell-inner', theme.cellInner || '');
      root.style.setProperty('--dual-active', theme.active || '');
      var copy = root.querySelector('.rg-dual-lottery__copy');
      if (copy) {
        var star = theme.star || config.defaultStar || '';
        copy.classList.toggle('is-starred', !!star);
        copy.classList.toggle('is-rays', isRays);
        if (star) copy.style.setProperty('--dual-star', "url('" + star + "')");
        else copy.style.removeProperty('--dual-star');
      }
      var layout = root.querySelector('.rg-dual-lottery__layout');
      if (layout) {
        if (theme.border) layout.style.background = theme.border;
        layout.style.setProperty('--dual-panel', theme.contentBg || '#fef5e4');
      }
    }

    function applyChrome() {
      var isRays = mode === 'rays';
      var phase = activityPhase();
      paintTheme(isRays);
      if (titleNode) titleNode.textContent = isRays ? config.raysTitle : config.subscribeTitle;
      if (descNode) {
        var description = isRays ? config.raysDescription : config.subscribeDescription;
        descNode.textContent = description || '';
        descNode.hidden = !description;
        descNode.classList.toggle('is-italic', isRays && !!config.raysDescriptionItalic && !!description);
      }
      if (subtitleNode) {
        var subtitle = isRays ? config.raysSubtitle : config.subscribeSubtitle;
        if (isRays && phase === 'soon' && config.soonNote) subtitle = config.soonNote;
        if (isRays && phase === 'ended' && config.endedNote) subtitle = config.endedNote;
        subtitleNode.textContent = subtitle || '';
        subtitleNode.hidden = !subtitle;
        subtitleNode.style.color = (isRays ? config.raysSubtitleColor : config.subscribeSubtitleColor) || '';
        if (isRays && phase === 'open' && customerPoints != null && customerPoints < (Number(config.raysPoints) || 0) && config.noPointsTips) {
          subtitleNode.textContent = config.noPointsTips;
          subtitleNode.hidden = false;
        }
      }
      if (heroNode) {
        var image = isRays ? config.raysMainImage : config.subscribeMainImage;
        heroNode.innerHTML = image ? '<img src="' + escapeHtml(image) + '" alt="">' : '';
        heroNode.hidden = !image;
      }
      if (isRays) {
        fillRules(config.raysRules, config.raysRulesButton, config.raysRulesText);
      } else {
        fillRules(config.subscribeRules, config.subscribeRulesButton, config.subscribeRulesText);
      }
      if (loginNode) loginNode.hidden = !(isRays && !config.loggedIn);
      if (subscribePanel) subscribePanel.hidden = isRays;
      if (raysPanel) raysPanel.hidden = !isRays;
      if (tabs) {
        tabs.hidden = !showTabs();
        tabs.querySelectorAll('[data-rg-dual-lottery-tab]').forEach(function (button) {
          var active = button.getAttribute('data-rg-dual-lottery-tab') === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
      renderCountdown();
    }

    function sharedNoneImage(nextMode) {
      var slots = slotConfig(nextMode);
      for (var i = 0; i < slots.length; i += 1) {
        var id = (slots[i] && slots[i].prizeId) || 'prize_none';
        if ((!id || id === 'prize_none') && slots[i].image) return slots[i].image;
      }
      return '';
    }

    function cellMarkup(slot) {
      if (slot.kind === 'none') {
        var image = slot.image
          ? '<img src="' + escapeHtml(slot.image) + '" alt="' + escapeHtml(config.noPrizeLabel) + '">'
          : '';
        var label = image ? '' : '<span>' + escapeHtml(config.noPrizeLabel) + '</span>';
        return (
          '<div class="rg-dual-lottery__cell' + (image ? '' : ' rg-dual-lottery__cell--none') + '" data-prize-id="prize_none">' +
            '<div class="rg-dual-lottery__cell-inner">' + image + label + '</div>' +
          '</div>'
        );
      }
      var prize = slot.prize || {};
      var detail = prize.productDetail || {};
      var image = detail.image ? '<img src="' + escapeHtml(detail.image) + '" alt="' + escapeHtml(detail.name || prize.title || '') + '">' : '';
      var label = image ? '' : '<span>' + escapeHtml(prize.title || '') + '</span>';
      return (
        '<div class="rg-dual-lottery__cell" data-prize-id="' + escapeHtml(prize.prizeId) + '">' +
          '<div class="rg-dual-lottery__cell-inner">' + image + label + '</div>' +
        '</div>'
      );
    }

    function renderGrid(prizes, nextMode) {
      var list = orderedPrizes(prizes, nextMode || mode).slice(0, SLOT_COUNT);
      var fallbackImage = sharedNoneImage(nextMode || mode);
      var slots = list.map(function (prize) {
        if (!prize || prize.prizeId === 'prize_none') {
          return { kind: 'none', image: (prize && prize.image) || fallbackImage };
        }
        return { kind: 'prize', prize: prize };
      });
      while (slots.length < SLOT_COUNT) slots.push({ kind: 'none', image: fallbackImage });
      var centerImage = mode === 'rays' ? config.raysCenterImage : config.subscribeCenterImage;
      var center;
      if (mode === 'rays') {
        var phase = activityPhase();
        var locked = phase === 'soon' || phase === 'ended';
        var useImage = !!centerImage && !locked;
        center = (
          '<button type="button" class="rg-dual-lottery__cell rg-dual-lottery__cell--center is-play' + (locked ? ' is-locked' : '') + (useImage ? ' has-image' : '') + '" data-rg-dual-lottery-play' + (useImage ? ' aria-label="' + escapeHtml(centerLabel()) + '"' : '') + '>' +
            (useImage
              ? '<img src="' + escapeHtml(centerImage) + '" alt="">'
              : '<span>' + escapeHtml(centerLabel()) + '</span>') +
          '</button>'
        );
      } else {
        center = (
          '<div class="rg-dual-lottery__cell rg-dual-lottery__cell--center">' +
            (centerImage ? '<img src="' + escapeHtml(centerImage) + '" alt="">' : '') +
          '</div>'
        );
      }
      if (!grid) return;
      grid.innerHTML = [
        cellMarkup(slots[0]),
        cellMarkup(slots[1]),
        cellMarkup(slots[2]),
        cellMarkup(slots[3]),
        center,
        cellMarkup(slots[4]),
        cellMarkup(slots[5]),
        cellMarkup(slots[6]),
        cellMarkup(slots[7])
      ].join('');
      grid.removeAttribute('data-loading');
    }

    function fetchPrizes(nextMode) {
      var activity = activityFor(nextMode);
      if (!activity) return Promise.resolve([]);
      if (prizeCache[activity]) return Promise.resolve(prizeCache[activity]);
      var url = site.apiUrl + '/api/lottery/prizes?activity=' + encodeURIComponent(activity) + '&store=' + encodeURIComponent(site.site);
      return fetch(url, { method: 'GET' })
        .then(function (response) { return response.json(); })
        .then(function (payload) {
          var prizes = payload && payload.data && Array.isArray(payload.data.prizes) ? payload.data.prizes : [];
          prizeCache[activity] = prizes;
          return prizes;
        });
    }

    function whenAuthReady() {
      if (window.RenogyAuth && typeof window.RenogyAuth.request === 'function') {
        return Promise.resolve();
      }
      if (document.readyState === 'complete') return Promise.resolve();
      return new Promise(function (resolve) {
        document.addEventListener('DOMContentLoaded', resolve, { once: true });
      });
    }

    function fetchMemberPoints() {
      if (!config.customerEmail) return Promise.resolve(null);
      var storeId = (window.renogyConfig && window.renogyConfig.storeId) || '1';
      var path = '/mem-service/api/v1/bigcommerce/get_user_information?storeId=' + storeId;
      return whenAuthReady().then(function () {
        if (!window.RenogyAuth || typeof window.RenogyAuth.request !== 'function') return null;
        return window.RenogyAuth.request(path, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          requireAuth: true
        });
      }).then(function (resp) {
        if (resp && resp.code === '000000' && resp.data) {
          customerPoints = resp.data.userBonusPoints;
          if (balanceNode) balanceNode.textContent = customerPoints;
          applyChrome();
        }
        return resp;
      }).catch(function () { return null; });
    }

    function fetchStatus() {
      return fetch(site.apiUrl + '/api/lottery/entry-status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: config.customerEmail || '',
          storeName: site.site
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (payload) {
          return payload && payload.data ? payload.data : null;
        });
    }

    var PRIZE_CLOSE_HTML = '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="1" y="1" width="24" height="24" rx="12" fill="white" fill-opacity="0.3"/><rect x="6.33295" y="18.4546" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-45 6.33295 18.4546)" fill="#1C1C1C"/><rect x="18.4548" y="19.667" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-135 18.4548 19.667)" fill="#1C1C1C"/></svg>';
    var PRIZE_LOSE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><rect width="28" height="28" fill="white"/><circle cx="14" cy="14" r="10" fill="#FCC061"/><ellipse cx="11.4" cy="12.2004" rx="1.4" ry="1.8" fill="#1C1C1C"/><ellipse cx="16.6" cy="12.2004" rx="1.4" ry="1.8" fill="#1C1C1C"/><line x1="11.8" y1="17.1992" x2="16.2" y2="17.1992" stroke="#1C1C1C" stroke-width="2" stroke-linecap="round"/></svg>';
    var PRIZE_COPY = {
      en: { redeemCopy: 'Copy and Use', giftCardCode: 'Gift Card Code:', checkEmail: 'Check Your Email', free: 'Free', code: 'Code', rules: 'Rules:', off: 'OFF', couponTitle: 'Congratulations! You got Coupon Code!', giftEmailTitle: 'Congratulations! You got Gift Card in your email!', giftTitle: 'Congratulations! You got a Gift Card!', productTitle: 'Congratulations! You got a Free Gift!', noDraw: 'Daily spins used up. Join next time!', noRays: 'Insufficient Rays. Earn more to play!' },
      de: { redeemCopy: 'Kopieren und Verwenden', giftCardCode: 'Geschenkkartencode:', checkEmail: 'Überprüfen Sie Ihre E-Mail', free: 'Kostenlos', code: 'Code', rules: 'Regeln:', off: 'AUS', couponTitle: 'Glückwunsch! Du hast einen Gutschein-Code erhalten!', giftEmailTitle: 'Glückwunsch! Du hast eine Geschenkkarte per E-Mail erhalten!', giftTitle: 'Glückwunsch! Du hast eine Geschenkkarte erhalten!', productTitle: 'Glückwunsch! Du hast ein kostenloses Geschenk erhalten!', noDraw: 'Tägliche Drehungen aufgebraucht. Nächstes Mal dabei sein!', noRays: 'Nicht genug Strahlen. Verdiene mehr, um zu spielen!' },
      ja: { redeemCopy: 'コピーして使用', giftCardCode: 'ギフトカードコード：', checkEmail: 'メールを確認', free: '無料', code: 'コード', rules: 'ルール:', off: 'オフ', couponTitle: 'おめでとうございます！クーポンコードを獲得しました！', giftEmailTitle: 'おめでとうございます！ギフトカードがメールに届きました！', giftTitle: 'おめでとうございます！ギフトカードを獲得しました！', productTitle: 'おめでとうございます！無料ギフトを獲得しました！', noDraw: '本日の回数制限です。次回ご参加ください！', noRays: 'レイが不足しています。もっと集めてプレイしましょう！', confirmEmail: 'メールアドレスをご確認ください。ギフトカードコードをお送りします。', confirmButton: '確認', emailPlaceholder: 'メールアドレスを入力...', loseTitle: '残念、今回は当たりませんでした', tryAgain: 'もう一度挑戦して賞品を獲得しましょう！' },
      fr: { redeemCopy: 'Copier et utiliser', giftCardCode: 'Code de carte cadeau :', checkEmail: 'Vérifiez vos emails', free: 'Gratuit', code: 'Code', rules: 'Règles:', off: 'ARRÊT', couponTitle: 'Félicitations ! Vous avez reçu un code promo !', giftEmailTitle: 'Félicitations ! Vous avez reçu une carte cadeau par e-mail !', giftTitle: 'Félicitations ! Vous avez reçu une carte cadeau !', productTitle: 'Félicitations ! Vous avez reçu un cadeau gratuit !', noDraw: 'Tours quotidiens épuisés. À la prochaine !', noRays: 'Rayons insuffisants. Gagnez-en plus pour jouer !' },
      nl: { redeemCopy: 'Kopiëren en gebruiken', giftCardCode: 'Cadeauboncode:', checkEmail: 'Controleer uw e-mail', free: 'Gratis', code: 'Code', rules: 'Regels:', off: 'UIT', couponTitle: 'Gefeliciteerd! Je hebt een kortingscode ontvangen!', giftEmailTitle: 'Gefeliciteerd! Je hebt een cadeaukaart per e-mail ontvangen!', giftTitle: 'Gefeliciteerd! Je hebt een cadeaukaart ontvangen!', productTitle: 'Gefeliciteerd! Je hebt een gratis cadeau ontvangen!', noDraw: 'Je dagelijkse draaiingen zijn op! Doe volgende keer nou weer mee!', noRays: 'Niet genoeg Strahlen. Verdien er meer om te spelen!' },
      es: { redeemCopy: 'Copiar y usar', giftCardCode: 'Código de tarjeta regalo:', checkEmail: 'Revisa tu correo electrónico', free: 'Gratis', code: 'Código', rules: 'Reglas:', off: 'APAGADO', couponTitle: '¡Felicidades! ¡Recibiste un código de cupón!', giftEmailTitle: '¡Felicidades! ¡Recibiste una tarjeta de regalo por correo electrónico!', giftTitle: '¡Felicidades! ¡Recibiste una tarjeta de regalo!', productTitle: '¡Felicidades! ¡Recibiste un regalo gratis!', noDraw: 'Giros diarios agotados. ¡Únete la próxima vez!', noRays: 'Rayos insuficientes. ¡Gana más para jugar!' },
      it: { redeemCopy: 'Copia e usa', giftCardCode: 'Codice della carta regalo:', checkEmail: 'Controlla la tua email', free: 'Gratis', code: 'Codice', rules: 'Regole:', off: 'SPENTO', couponTitle: 'Congratulazioni! Hai ricevuto un codice coupon!', giftEmailTitle: 'Congratulazioni! Hai ricevuto una carta regalo via email!', giftTitle: 'Congratulazioni! Hai ricevuto una carta regalo!', productTitle: 'Congratulazioni! Hai ricevuto un regalo gratuito!', noDraw: 'Giri del giorno finiti! Ci ritroviamo alla prossima!', noRays: 'Raggi insufficienti. Guadagnane di più per giocare!' }
    };

    function prizeCopy() {
      var locale = String((window.Shopify && window.Shopify.locale) || 'en').toLowerCase();
      var copy = PRIZE_COPY[locale] || PRIZE_COPY.en;
      return Object.assign({
        confirmEmail: 'Please confirm the email, you will receive GiftCard Code in it.',
        confirmButton: 'Confirm',
        emailPlaceholder: 'Enter your email...',
        loseTitle: 'Sorry, No Luck This Time',
        tryAgain: 'Try more times to win a prize!'
      }, copy);
    }

    function prizeLang() {
      var locale = String((window.Shopify && window.Shopify.locale) || 'en').toLowerCase();
      return PRIZE_COPY[locale] ? locale : '';
    }

    function shopMoney() {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var locale = ((window.Shopify && window.Shopify.locale) || 'en') + '-' + ((window.Shopify && window.Shopify.country) || 'US');
      var formatter;
      try {
        formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
      } catch (error) {
        formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      }
      var symbol = currency;
      formatter.formatToParts(0).some(function (part) {
        if (part.type !== 'currency') return false;
        symbol = part.value;
        return true;
      });
      return { symbol: symbol, format: function (amount) { return formatter.format(amount); } };
    }

    function prizeSlot(prize) {
      var slots = slotConfig(mode);
      for (var i = 0; i < slots.length; i += 1) {
        if (slots[i] && slots[i].prizeId === prize.prizeId) return slots[i];
      }
      return null;
    }

    function prizeRulesHtml(prize) {
      var slot = prizeSlot(prize);
      if (slot && configured(slot.rules)) return slot.rules;
      var rules = prize.rulesHtml || prize.prizeRules || prize.rules || '';
      if (Array.isArray(rules)) return rules.join('');
      return rules;
    }

    function prizeDisplayName(prize) {
      var slot = prizeSlot(prize);
      if (slot && configured(slot.prizeName)) return slot.prizeName;
      if (mode === 'rays') return prize.prizeTitle || prize.title || '';
      return prize.title || prize.prizeTitle || '';
    }

    function prizeUseLimit(prize) {
      var slot = prizeSlot(prize);
      if (slot && configured(slot.prizeDescription)) return slot.prizeDescription;
      return prize.prizeUseLimit || prize.useLimit || '';
    }

    function prizeValidDate(prize) {
      var slot = prizeSlot(prize);
      if (slot && configured(slot.validDate)) return slot.validDate;
      return prize.prizeValidate || prize.validate || '';
    }

    function prizeMinPurchase(prize) {
      var slot = prizeSlot(prize);
      if (slot && configured(slot.minPurchase)) return slot.minPurchase;
      return prize.minPurchase || '';
    }

    function subscribePurchaseText(prize, money) {
      var limit = prizeUseLimit(prize);
      var minPurchase = String(prizeMinPurchase(prize) || '').trim();
      if (!minPurchase) return escapeHtml(limit);
      return escapeHtml(limit) + (limit ? ' ' : '') + escapeHtml(money.symbol) + ' ' + escapeHtml(minPurchase);
    }

    function prizeCouponType(prize) {
      var slot = prizeSlot(prize);
      if (slot && configured(slot.couponTypeName)) return slot.couponTypeName;
      return prize.couponTypeName || '';
    }

    function subscribeProduct(prize) {
      var sku = String(prize.prizeSku || (prize.productDetail && prize.productDetail.sku) || (prize.prizeProductDetail && prize.prizeProductDetail.sku) || '').trim();
      var list = Array.isArray(config.productList) ? config.productList : [];
      var found = null;
      list.some(function (product) {
        var variants = product && product.variants ? product.variants : [];
        return variants.some(function (variant) {
          if (!sku || String(variant.sku || '') !== sku) return false;
          found = {
            id: variant.id,
            sku: variant.sku || '',
            name: variant.name || product.title || '',
            price: variant.price,
            cents: true,
            url: product.handle && variant.id ? '/' + product.handle + '?variant=' + variant.id : (product.url || ''),
            image: (variant.featured_image && variant.featured_image.src) || (product.featured_image && product.featured_image.src) || (product.images && product.images[0] && (product.images[0].src || product.images[0])) || (prize.productDetail && prize.productDetail.image) || ''
          };
          return true;
        });
      });
      return found;
    }

    function productDetail(prize) {
      if (mode !== 'rays') {
        var matched = subscribeProduct(prize);
        if (matched) return matched;
        return {
          id: '',
          sku: '',
          name: '',
          price: '',
          cents: false,
          url: '',
          image: (prize.productDetail && prize.productDetail.image) || ''
        };
      }
      var detail = prize.prizeProductDetail || {};
      return {
        id: detail.variantId || detail.productId || '',
        sku: detail.sku || '',
        name: detail.name || '',
        price: detail.price,
        cents: false,
        url: detail.link || '',
        image: detail.image || ''
      };
    }

    function afterPrizeDialog() {
      if (root.getAttribute('data-pending-rays') !== '1') return;
      root.removeAttribute('data-pending-rays');
      finishSubscribeDraw();
    }

    function openPrizePopup(html) {
      if (!window.Swal) return Promise.resolve();
      return window.Swal.fire({
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        html: html,
        closeButtonHtml: PRIZE_CLOSE_HTML,
        customClass: {
          container: 'membership-coupon-popup-container',
          popup: 'membership-coupon-popup'
        }
      }).then(function () {
        afterPrizeDialog();
      });
    }

    function bindPrizeCopy(rootNode, code, watchCartSuccess) {
      var button = rootNode.querySelector('.membership-coupon-b-top-button-copy');
      if (!button) return;
      button.addEventListener('click', function () {
        if (watchCartSuccess) {
          var elapsed = 0;
          var timer = window.setInterval(function () {
            if (button.classList.contains('is-success')) {
              if (window.Swal) window.Swal.close();
              window.clearInterval(timer);
            }
            elapsed += 50;
          }, 10);
          if (elapsed >= 3000) {
            if (window.Swal) window.Swal.close();
            window.clearInterval(timer);
          }
        }
        if (button.classList.contains('copied')) return;
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(code || '').then(function () {
          var original = button.textContent;
          if (!watchCartSuccess) {
            button.innerHTML = original + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          }
          button.classList.add('copied');
          window.setTimeout(function () {
            button.innerHTML = original;
            button.classList.remove('copied');
          }, 3000);
        });
      });
    }

    function rulesBlock(prize, copy) {
      return '<div class="membership-coupon-b-bottom-rules-container"><div class="membership-coupon-b-bottom-rules-title">' + escapeHtml(copy.rules) + '</div><div class="membership-coupon-b-bottom-rules-box">' + prizeRulesHtml(prize) + '</div></div>';
    }

    function showCouponDialog(prize) {
      var copy = prizeCopy();
      var money = shopMoney();
      var name = prizeDisplayName(prize);
      var limit = prizeUseLimit(prize);
      var code = prize.prizeValue || prize.value || '';
      var nameHtml = '';
      if (mode === 'rays') {
        var percentTitle = String(name).indexOf('%') !== -1;
        nameHtml = percentTitle
          ? '<span>' + escapeHtml(String(name).replace('%', '').trim()) + '</span><span class="copun-currency">%</span>'
          : '<span class="copun-currency">' + escapeHtml(money.symbol) + '</span><span>' + escapeHtml(String(name).replace(money.symbol, '').trim()) + '</span>';
        limit = prizeUseLimit(prize);
      } else {
        var percent = prizeCouponType(prize) === '%';
        nameHtml = (percent ? '' : '<span class="copun-currency">' + escapeHtml(money.symbol) + '</span>') +
          '<span>' + escapeHtml(name) + '</span>' +
          (percent ? '<span class="copun-currency">%</span>' : '');
        limit = subscribePurchaseText(prize, money);
      }
      var title = copy.couponTitle;
      var html = '<div class="membership-coupon-dialog-content-success membership-coupon-container coupon-dialog-success">' +
        '<div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">' + escapeHtml(title) + '</div>' +
        '<div class="membership-coupon-item"><div class="membership-coupon-top"><div class="coupon-l"><div class="coupon-name">' + nameHtml + '<span class="off-text">' + escapeHtml(copy.off) + '</span></div><div class="account-coupon-info">' + (mode === 'rays' ? escapeHtml(limit) : limit) + '</div></div></div>' +
        '<div class="membership-coupon-b"><div class="membership-coupon-b-top"><div class="membership-coupon-b-top-content"><div class="membership-coupon-b-top-content-title">' + escapeHtml(copy.code) + '</div><div class="membership-coupon-b-top-content-des">' + escapeHtml(code) + '</div></div><div class="membership-coupon-b-top-button membership-coupon-b-top-button-copy">' + escapeHtml(copy.redeemCopy) + '</div></div><div class="membership-coupon-b-line"></div><div class="membership-coupon-b-bottom"><div class="membership-coupon-b-bottom-time">' + escapeHtml(prizeValidDate(prize)) + '</div></div></div></div>' +
        rulesBlock(prize, copy) + '</div>';
      openPrizePopup(html);
      window.setTimeout(function () {
        var popup = document.querySelector('.membership-coupon-popup');
        if (popup) bindPrizeCopy(popup, code, false);
      }, 0);
    }

    function showGiftCardDialog(prize, fromConfirm) {
      var copy = prizeCopy();
      var money = shopMoney();
      var title = mode === 'rays' ? copy.giftTitle : copy.giftEmailTitle;
      var amount = mode === 'rays' ? (prize.prizeValue || '') : prizeDisplayName(prize);
      var limit = mode === 'rays' ? escapeHtml(prizeUseLimit(prize)) : subscribePurchaseText(prize, money);
      var html = '<div class="membership-coupon-dialog-content-success membership-coupon-container gift-card-coupon-dialog-success">' +
        '<div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">' + escapeHtml(title) + '</div>' +
        '<div class="membership-coupon-item"><div class="membership-coupon-top"><div class="coupon-l"><div class="coupon-name"><span class="copun-currency">' + escapeHtml(money.symbol) + '</span><span>' + escapeHtml(amount) + '</span>' + (mode === 'rays' ? '<span class="off-text">' + escapeHtml(copy.off) + '</span>' : '') + '</div><div class="account-coupon-info">' + limit + '</div></div></div>' +
        '<div class="membership-coupon-b"><div class="membership-coupon-b-top"><div class="membership-coupon-b-top-content"><div class="membership-coupon-b-top-content-title">' + escapeHtml(copy.giftCardCode) + '</div><div class="membership-coupon-b-top-content-des">' + escapeHtml(copy.checkEmail) + '</div></div></div><div class="membership-coupon-b-line"></div><div class="membership-coupon-b-bottom"><div class="membership-coupon-b-bottom-time">' + escapeHtml(prizeValidDate(prize)) + '</div></div></div></div>' +
        rulesBlock(prize, copy) + '</div>';
      if (fromConfirm) {
        openPrizePopup(html);
        return;
      }
      openPrizePopup(html);
    }

    function claimGiftCard(prizeId, email, fixEmail) {
      var lang = prizeLang();
      var url = site.apiUrl + '/api/lottery/claim' + (lang ? '?lang=' + encodeURIComponent(lang) : '');
      var payload = {
        email: email || '',
        storeName: site.site,
        activity: activityFor(mode),
        prizeId: prizeId
      };
      payload.findsql = true;
      if (fixEmail && fixEmail !== email) payload.fixEmail = fixEmail;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    }

    function showGiftConfirm(prize, email) {
      var copy = prizeCopy();
      var continued = false;
      var html = '<div class="membership-coupon-confirm-container membership-coupon-dialog-content-success membership-coupon-container">' +
        '<div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">' + escapeHtml(copy.giftTitle) + '</div>' +
        '<div class="membership-coupon-dialog-content"><div class="membership-coupon-dialog-content-title">' + escapeHtml(copy.confirmEmail) + '</div>' +
        '<form method="post" id="subscript-email-confirm" accept-charset="UTF-8" class="form subscript-form"><div class="form__field"><div class="input-with-button input-with-button--md-up">' +
        '<input type="email" class="input w-full focus-inset" id="subscript-email-confirm-input" name="sub-email" value="' + escapeHtml(email || '') + '" placeholder="' + escapeHtml(copy.emailPlaceholder) + '" autocomplete="email" aria-required="true" required="">' +
        '</div><button class="btn btn--primary subscript-button-confirm" type="button">' + escapeHtml(copy.confirmButton) + '</button></div></form></div></div>';
      if (!window.Swal) return;
      window.Swal.fire({
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        html: html,
        closeButtonHtml: PRIZE_CLOSE_HTML,
        customClass: {
          container: 'membership-coupon-popup-container',
          popup: 'membership-coupon-popup'
        },
        didOpen: function () {
          var button = document.querySelector('.subscript-button-confirm');
          if (!button) return;
          button.addEventListener('click', function (event) {
            event.preventDefault();
            var input = document.getElementById('subscript-email-confirm-input');
            var nextEmail = input ? input.value : email;
            continued = true;
            claimGiftCard(prize.prizeId, email, nextEmail);
            showGiftCardDialog(prize, true);
          });
        }
      }).then(function () {
        if (!continued) afterPrizeDialog();
      });
    }

    function showProductDialog(prize) {
      var copy = prizeCopy();
      var money = shopMoney();
      var product = productDetail(prize);
      var code = prize.prizeValue || prize.value || '';
      var image = product.image
        ? '<div class="product-card-img"><img width="100%" src="' + escapeHtml(product.image) + '" alt=""></div>'
        : (mode === 'rays'
          ? '<div class="product-card-img" style="background:#F2FCFF;"></div>'
          : '<div class="product-card-img"><img width="100%" src="" alt=""></div>');
      var priceHtml = '';
      if (product.price != null && product.price !== '') {
        var amount = Number(product.price);
        if (product.cents && money.symbol !== '¥') amount = amount / 100;
        priceHtml = '<span class="underline-price">' + escapeHtml(money.format(amount)) + '</span>';
      }
      var cartId = product.id;
      var cart = cartId
        ? '<product-form><form class="js-product-form" id="form-id-' + escapeHtml(cartId) + '" method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="' + escapeHtml(cartId) + '" disabled><button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn">' + escapeHtml(copy.redeemCopy) + '</button></form></product-form>'
        : '';
      var title = copy.productTitle;
      var html = '<div class="membership-coupon-dialog-content-success membership-coupon-container product-card-coupon-dialog-success">' +
        '<div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">' + escapeHtml(title) + '</div>' +
        '<div class="membership-coupon-item"><div class="membership-coupon-top membership-coupon-product-card">' + image +
        '<div class="product-card-content"><a class="product-card-content-title" target="_blank" href="' + escapeHtml(product.url || '') + '">' + escapeHtml(product.name || '') + '</a><div class="product-card-content-sku">' + escapeHtml(product.sku || '') + '</div><div class="product-card-content-price"><span class="free">' + escapeHtml(copy.free) + '</span>' + priceHtml + '</div></div></div>' +
        '<div class="membership-coupon-item-line-box"><div class="membership-coupon-item-line"></div></div>' +
        '<div class="membership-coupon-b" style="gap:0;"><div class="membership-coupon-b-top"><div class="membership-coupon-b-top-content"><div class="membership-coupon-b-top-content-title">' + escapeHtml(copy.code) + ': <span class="membership-coupon-b-top-content-des">' + escapeHtml(code) + '</span></div></div>' + cart + '</div><div class="membership-coupon-b-bottom"><div class="membership-coupon-b-bottom-time">' + escapeHtml(prizeValidDate(prize)) + '</div></div></div></div>' +
        rulesBlock(prize, copy) + '</div>';
      openPrizePopup(html);
      window.setTimeout(function () {
        var popup = document.querySelector('.membership-coupon-popup');
        if (popup) bindPrizeCopy(popup, code, true);
      }, 0);
    }

    function readLotteryCookie(activityId) {
      if (!activityId) return null;
      var name = 'activity_lottery_' + activityId + '=';
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i += 1) {
        var cookie = parts[i].trim();
        if (cookie.indexOf(name) !== 0) continue;
        try {
          return JSON.parse(decodeURIComponent(cookie.substring(name.length)));
        } catch (error) {
          return null;
        }
      }
      return null;
    }

    function writeLotteryCookie(activityId, count) {
      if (!activityId) return;
      var existing = readLotteryCookie(activityId);
      var today = new Date().toDateString();
      var payload = mode === 'rays'
        ? { activityId: activityId, raysLotteryCount: count, lastUpdated: new Date().toISOString(), createdAt: (existing && existing.createdAt) || today }
        : { activityId: activityId, lotteryCount: count };
      var expires = '';
      if (mode === 'rays') {
        var end = new Date();
        if (existing && existing.createdAt === today) {
          end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
        } else {
          end.setDate(end.getDate() + 1);
        }
        expires = '; expires=' + end.toUTCString();
      }
      document.cookie = 'activity_lottery_' + activityId + '=' + encodeURIComponent(JSON.stringify(payload)) + expires + '; path=/; SameSite=Lax';
    }

    function bumpDrawCount() {
      var activityId = activityFor(mode);
      var existing = readLotteryCookie(activityId) || {};
      var count = mode === 'rays' ? (Number(existing.raysLotteryCount) || 0) : (Number(existing.lotteryCount) || 0);
      writeLotteryCookie(activityId, count + 1);
    }

    function showLimitToast(message) {
      if (!window.Swal) {
        setMessage(message);
        return;
      }
      window.Swal.fire({
        toast: true,
        position: 'center',
        title: message,
        iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><rect x="6" y="8" width="16" height="16" rx="8" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/><path d="M14 12V15.6C14 15.8209 14.1791 16 14.4 16H18" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/><line x1="12" y1="5" x2="16" y2="5" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/><path d="M15 7.29961L13 7.29961L13 4.59961L15 4.59961L15 7.29961Z" fill="#00C0FF"/><line x1="20" y1="9.58579" x2="20.99" y2="8.59584" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/></svg>',
        customClass: {
          popup: 'custom-error-toast',
          container: 'custom-error-toast-container'
        },
        showConfirmButton: false,
        timer: 3000
      });
    }

    function showLoseDialog() {
      var existing = readLotteryCookie(activityFor(mode)) || {};
      var count = mode === 'rays' ? (Number(existing.raysLotteryCount) || 0) : (Number(existing.lotteryCount) || 0);
      var limit = mode === 'rays' ? (Number(config.raysDailyCount) || 1) : 1;
      var tryAgain = count < limit;
      var html = '<div class="membership-coupon-confirm-container membership-coupon-dialog-content-success membership-coupon-container">' +
        '<div class="membership-coupon-dialog-title">' + PRIZE_LOSE_ICON + escapeHtml(prizeCopy().loseTitle) + '</div>' +
        (tryAgain ? '<div class="membership-coupon-dialog-content"><div class="membership-coupon-dialog-content-title" style="text-align:left;">' + escapeHtml(prizeCopy().tryAgain) + '</div></div>' : '') +
        '</div>';
      openPrizePopup(html);
    }

    function closeResult() {
      if (window.Swal && window.Swal.isVisible && window.Swal.isVisible()) window.Swal.close();
      if (resultNode) {
        resultNode.hidden = true;
        resultNode.innerHTML = '';
      }
    }

    function showResult(data, lost, email) {
      var prize = data || {};
      if (lost) {
        showLoseDialog();
        return;
      }
      if (prize.prizeType === 'coupon_code') {
        showCouponDialog(prize);
        return;
      }
      if (prize.prizeType === 'gift_card') {
        if (mode === 'rays') {
          showGiftCardDialog(prize, false);
          claimGiftCard(prize.prizeId, email);
          return;
        }
        showGiftConfirm(prize, email);
        return;
      }
      if (prize.prizeType === 'product_coupon') {
        showProductDialog(prize);
        return;
      }
      afterPrizeDialog();
    }

    function finishSubscribeDraw() {
      if (!config.loggedIn) return;
      config.subscribed = true;
      mode = 'rays';
      applyChrome();
      if (grid) grid.setAttribute('data-loading', 'true');
      fetchPrizes('rays').then(function (prizes) {
        if (mode === 'rays') renderGrid(prizes);
      }).catch(function () {
        if (grid) grid.removeAttribute('data-loading');
        setMessage(config.genericError);
      });
    }

    function prizeItems() {
      return Array.from(root.querySelectorAll('.rg-dual-lottery__cell:not(.rg-dual-lottery__cell--center)'));
    }

    function clearActive() {
      prizeItems().forEach(function (item) {
        item.classList.remove('is-active');
      });
    }

    function stopAnimation() {
      if (animation) animation.running = false;
      clearActive();
      spinning = false;
    }

    function runStep() {
      if (!animation || !animation.running) return;
      var anim = animation;
      if (anim.current) anim.current.classList.remove('is-active');
      var sequenceIndex = anim.step % CLOCKWISE.length;
      var prizeIndex = CLOCKWISE[sequenceIndex];
      anim.current = anim.items[prizeIndex] || null;
      if (anim.current) anim.current.classList.add('is-active');
      anim.step += 1;
      if (anim.hasTarget && anim.step > anim.totalSteps) {
        anim.running = false;
        spinning = false;
        window.setTimeout(function () {
          if (anim.resolve) anim.resolve();
        }, 500);
        return;
      }
      var nextDuration = anim.duration;
      if (anim.hasTarget) {
        var remaining = anim.totalSteps - anim.step + 1;
        if (remaining <= 8) nextDuration = anim.duration * (1 + (8 - remaining) * 0.3);
      }
      window.setTimeout(runStep, nextDuration);
    }

    function startAnimation() {
      stopAnimation();
      spinning = true;
      var items = prizeItems();
      animation = {
        running: true,
        hasTarget: false,
        duration: 100,
        items: items,
        step: 0,
        current: null,
        resolve: null
      };
      var promise = new Promise(function (resolve) {
        animation.resolve = resolve;
      });
      runStep();
      return promise;
    }

    function setTarget(targetPrizeId, isNoLuck) {
      if (!animation || !animation.running) return;
      var targetIndex = -1;
      if (isNoLuck) {
        var noneIndexes = [];
        animation.items.forEach(function (item, index) {
          if (item.getAttribute('data-prize-id') === 'prize_none') noneIndexes.push(index);
        });
        if (!noneIndexes.length) {
          animation.running = false;
          spinning = false;
          clearActive();
          if (animation.resolve) animation.resolve();
          return;
        }
        targetIndex = noneIndexes[Math.floor(Math.random() * noneIndexes.length)];
      } else {
        animation.items.forEach(function (item, index) {
          if (item.getAttribute('data-prize-id') === targetPrizeId) targetIndex = index;
        });
        if (targetIndex === -1) {
          animation.running = false;
          spinning = false;
          clearActive();
          if (animation.resolve) animation.resolve();
          return;
        }
      }
      var currentSequenceIndex = animation.step % CLOCKWISE.length;
      var targetSequenceIndex = CLOCKWISE.indexOf(targetIndex);
      var stepsToTarget = targetSequenceIndex - currentSequenceIndex;
      if (stepsToTarget <= 0) stepsToTarget += CLOCKWISE.length;
      animation.hasTarget = true;
      animation.totalSteps = animation.step + (CLOCKWISE.length * 2) + stepsToTarget;
    }

    function findPrize(prizeId) {
      var prizes = prizeCache[activityFor(mode)] || [];
      for (var i = 0; i < prizes.length; i += 1) {
        if (prizes[i].prizeId === prizeId) return prizes[i];
      }
      return null;
    }

    function apiErrorMessage(error) {
      var text = error && error.message ? String(error.message) : '';
      var start = text.indexOf('{');
      if (start === -1) return '';
      try {
        var payload = JSON.parse(text.slice(start));
        return payload && payload.msg ? payload.msg : '';
      } catch (parseError) {
        return '';
      }
    }

    function play() {
      if (spinning) return;
      setMessage('');
      closeResult();
      if (mode === 'rays') {
        var phase = activityPhase();
        if (phase === 'soon' || phase === 'ended') {
          setMessage(phase === 'soon' ? (config.soonNote || config.playSoon) : (config.endedNote || config.playEnded));
          return;
        }
        if (!config.loggedIn) {
          if (config.loginUrl) window.location.href = config.loginUrl;
          else setMessage(config.loginRequired);
          return;
        }
        if (!accessToken) {
          setMessage(config.loginRequired);
          return;
        }
      } else {
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email) {
          setMessage(config.emailRequired);
          return;
        }
        if (termsInput && !termsInput.checked) {
          setMessage(config.termsRequired);
          return;
        }
        var subscribeCount = Number((readLotteryCookie(activityFor(mode)) || {}).lotteryCount) || 0;
        if (subscribeCount >= 1) {
          showLimitToast(prizeCopy().noDraw);
          return;
        }
      }
      if (mode === 'rays') {
        var raysCount = Number((readLotteryCookie(activityFor(mode)) || {}).raysLotteryCount) || 0;
        if (raysCount >= (Number(config.raysDailyCount) || 1)) {
          showLimitToast(prizeCopy().noDraw);
          return;
        }
        if (customerPoints != null && customerPoints < (Number(config.raysPoints) || 0)) {
          showLimitToast(prizeCopy().noRays);
          return;
        }
      }

      var animationPromise = startAnimation();
      var lang = prizeLang();
      var url = site.apiUrl + (mode === 'rays' ? '/api/lottery/draw-rays' : '/api/lottery/draw') + (lang ? '?lang=' + encodeURIComponent(lang) : '');
      var body = {
        email: mode === 'rays' ? (config.customerEmail || '') : (emailInput ? emailInput.value.trim() : ''),
        storeName: site.site,
        activity: activityFor(mode)
      };
      var headers = { 'Content-Type': 'application/json' };
      if (mode !== 'rays') {
        body.tagName = String(config.subscribeTag || '').trim() || activityFor('subscribe');
      }
      if (mode === 'rays') {
        body.limit = {
          day: 1,
          count: Number(config.raysDailyCount) || 1,
          memberCheck: true,
          costRays: Number(config.raysPoints) || 0
        };
      }

      var requestPromise = mode === 'rays'
        ? whenAuthReady().then(function () {
            if (window.RenogyAuth && typeof window.RenogyAuth.request === 'function') {
              return window.RenogyAuth.request(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
                requireAuth: true
              });
            }
            headers['X-Token'] = accessToken;
            return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body) })
              .then(function (response) { return response.json(); });
          })
        : fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body) })
            .then(function (response) { return response.json(); });

      requestPromise
        .then(function (payload) {
          var data = payload && payload.data ? payload.data : {};
          var won = payload && Number(payload.code) === 200 && data.success && data.prizeId && data.prizeId !== 'none';
          if (Number(payload && payload.code) === 200) {
            bumpDrawCount();
            setTarget(won ? data.prizeId : 'prize_none', !won);
          } else {
            stopAnimation();
            setMessage((payload && payload.msg) || config.genericError);
            if (config.loggedIn && mode === 'subscribe') {
              fetchStatus().then(function (status) {
                if (status && status.subscribed) finishSubscribeDraw();
              }).catch(function () {});
            }
            return null;
          }
          return animationPromise.then(function () {
            var localPrize = won ? findPrize(data.prizeId) : null;
            var view = localPrize ? Object.assign({}, localPrize, data) : data;
            if (config.loggedIn && mode === 'subscribe') {
              root.setAttribute('data-pending-rays', '1');
            }
            showResult(applyImage(view, mode), !won, body.email);
            if (mode === 'rays') fetchMemberPoints();
          });
        })
        .catch(function (error) {
          stopAnimation();
          setMessage(apiErrorMessage(error) || config.genericError);
        });
    }

    function switchMode(nextMode) {
      if (spinning || nextMode === mode || !showTabs()) return;
      if (!config.loggedIn && nextMode === 'rays') {
        if (config.memberLoginUrl) window.location.href = config.memberLoginUrl;
        return;
      }
      mode = nextMode;
      applyChrome();
      setMessage('');
      closeResult();
      var serial = ++requestSerial;
      if (grid) grid.setAttribute('data-loading', 'true');
      fetchPrizes(nextMode).then(function (prizes) {
        if (serial !== requestSerial || mode !== nextMode) return;
        renderGrid(prizes, nextMode);
        if (!prizes.length && !slotConfig(nextMode).length) setMessage(config.emptyPrizes);
      }).catch(function () {
        if (serial !== requestSerial) return;
        if (grid) grid.removeAttribute('data-loading');
        setMessage(config.genericError);
      });
    }

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-rg-dual-lottery-tab]');
      if (tab && root.contains(tab)) {
        switchMode(tab.getAttribute('data-rg-dual-lottery-tab'));
        return;
      }
      if (event.target.closest('[data-rg-dual-lottery-rules-more]')) {
        openRules();
        return;
      }
      if (event.target.closest('[data-rg-dual-lottery-play]')) {
        play();
        return;
      }
      if (event.target.closest('[data-rg-dual-lottery-close]')) {
        closeResult();
        if (root.getAttribute('data-pending-rays') === '1') {
          root.removeAttribute('data-pending-rays');
          finishSubscribeDraw();
        }
        return;
      }
      var copyButton = event.target.closest('[data-rg-dual-lottery-copy]');
      if (copyButton && navigator.clipboard) {
        navigator.clipboard.writeText(copyButton.getAttribute('data-rg-dual-lottery-copy') || '').then(function () {
          copyButton.textContent = config.copiedLabel;
        });
      }
    });

    if (emailInput && config.customerEmail && !emailInput.value) {
      emailInput.value = config.customerEmail;
    }

    renderCountdown();
    window.setInterval(renderCountdown, 1000);

    var statusPromise = config.loggedIn ? fetchStatus().catch(function () { return null; }) : Promise.resolve(null);
    statusPromise.then(function (status) {
      if (status && typeof status.subscribed === 'boolean') config.subscribed = status.subscribed;
      mode = pickMode();
      applyChrome();
      if (config.customerEmail) fetchMemberPoints();
      return fetchPrizes(mode);
    }).then(function (prizes) {
      renderGrid(prizes || []);
      if (skeleton) skeleton.hidden = true;
      if (body) body.hidden = false;
      if (!(prizes || []).length && !slotConfig(mode).length) setMessage(config.emptyPrizes);
    }).catch(function () {
      if (skeleton) skeleton.hidden = true;
      if (body) body.hidden = false;
      applyChrome();
      setMessage(config.genericError);
    });
  }

  function bootAll(scope) {
    if (scope && scope.matches && scope.matches('[data-rg-dual-lottery]')) boot(scope);
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-rg-dual-lottery]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootAll(event.target || document);
  });
})();
